import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getAnnouncementsRequest: ["navigate"],
  getAnnouncementsSuccess: ["announcements"],
  getAnnouncementsFailure: null,
});

export const GetAnnouncementsTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetching: null,
  success: null,
  error: null,
  announcements: null,
});

export const GetAnnouncementsSelectors = {
  getData: (state: any) => state.getAnnouncements.data,
  isFetching: (state: any) => state.getAnnouncements.fetching,
  isSuccess: (state: any) => state.getAnnouncements.success,
  hasError: (state: any) => state.getAnnouncements.error,
};

export const request = (state: any, action: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    announcements: null,
  };
  
  // Handle both Immutable and plain JavaScript objects
  if (state && typeof state.merge === 'function') {
    return state.merge(updateData);
  } else {
    return { ...state, ...updateData };
  }
};

export const success = (state: any, action: any) => {
  const { announcements } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    announcements,
  };
  
  // Handle both Immutable and plain JavaScript objects
  if (state && typeof state.merge === 'function') {
    return state.merge(updateData);
  } else {
    return { ...state, ...updateData };
  }
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    announcements: null,
  };
  
  // Handle both Immutable and plain JavaScript objects
  if (state && typeof state.merge === 'function') {
    return state.merge(updateData);
  } else {
    return { ...state, ...updateData };
  }
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_ANNOUNCEMENTS_REQUEST]: request,
  [Types.GET_ANNOUNCEMENTS_SUCCESS]: success,
  [Types.GET_ANNOUNCEMENTS_FAILURE]: failure,
});
